import React, { useState } from "react";
import { Card } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { update } from "../../../store/features/orders/createSlice";

const OrderType = () => {
  const [type, setType] = useState("");
  const dispatch = useDispatch();
  const orderStoreDetails = useSelector((state) => state.order.orders);

  return (
    <div className="order-type-pg">
      <Card
        style={{
          width: 300,
        }}
        className={orderStoreDetails.type === "onhand" && "selected-type"}
        onClick={(e) => dispatch(update({ type: "onhand" }))}
      >
        <h2>On Hand</h2>
      </Card>
      <br />
      <Card
        style={{
          width: 300,
        }}
        className={orderStoreDetails.type === "courier" && "selected-type"}
        onClick={(e) => dispatch(update({ type: "courier" }))}
      >
        <h2>Courier</h2>
      </Card>
    </div>
  );
};
export default OrderType;
